const FAQS = [
  {
    q: '每日吃瓜的视频是免费观看的吗？',
    a: '是的，每日吃瓜平台上绝大部分明星大瓜视频和吃瓜现场内容均可免费在线观看。我们每日更新大量高清吃瓜视频合集，无需付费即可畅享一站式追更体验。部分独家深度专题内容可能需要注册会员后观看。',
  },
  {
    q: '视频更新频率如何？每天更新多少条大瓜视频？',
    a: '我们的编辑团队保持7×24小时全天候追踪娱乐圈最新动态，平均每日更新20条以上的明星爆瓜视频和吃瓜现场实录。重大娱乐圈事件发生时，我们会在第一时间上线相关视频，确保瓜友们不错过任何一个大瓜。',
  },
  {
    q: '视频播放卡顿怎么办？支持哪些清晰度？',
    a: '每日吃瓜采用多线服务器智能加速技术，所有视频默认提供高清画质。如果遇到卡顿，建议检查当前网络环境或切换至较低清晰度播放。我们支持流畅、标清、高清和超清四种清晰度选项，根据网络状况自动适配最佳播放体验。',
  },
  {
    q: '如何在手机上观看每日吃瓜的视频？',
    a: '你可以通过手机浏览器直接访问每日吃瓜网站，页面已针对移动端进行适配优化。同时我们也提供了iOS和Android客户端——追瓜神器APP，支持离线缓存、推送提醒和弹幕互动等专属功能，在各大应用商店搜索"每日吃瓜"即可下载。',
  },
  {
    q: '我有独家爆料想投稿，如何联系你们？',
    a: '欢迎通过本站"投稿爆料"入口提交你的独家明星大瓜爆料或吃瓜现场视频。你也可以发送邮件至 tougao@meirichigua.com，我们的编辑团队将在24小时内审核并回复。对于重大独家爆料，我们会提供相应的稿酬奖励。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-18 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">常见问题</h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            关于每日吃瓜的使用和吃瓜视频观看，这里有你想要的答案
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {FAQS.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6"
            >
              <h3 className="font-heading text-base md:text-lg text-foreground-950 mb-2 flex items-start gap-3">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">
                  <i className="ri-question-answer-line"></i>
                </span>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-700 leading-relaxed pl-8">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}